export default __webpack_public_path__ + "static/media/windows.67f10d82.svg";